import { Button, Modal, Space, Table, Form, DatePicker, Input } from "antd";
import React, { useEffect, useState } from "react";
import PrescriptionDetails from "./PrescriptionDetails";
import ConsultationService from "../../../../../Services/ConsultationService";
import NoDataFound from "../../../../../Assets/Icons/NoDataCard2.svg";
import dayjs from "dayjs";
import { useForm } from "antd/es/form/Form";
import moment from "moment";
import { FaFilter } from "react-icons/fa6";

function ViewPrescription({ selectedPatient, permissionData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [prescriptionsList, setPrescriptionsList] = useState([]);
  const [selectedPrescription, setSelectedPrescription] = useState({});
  const [loading, setLoading] = useState(true);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [form, setForm] = useForm();
  const [toDate, setToDate] = useState("");

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    fetchPatientPermission();
  }, []);

  const showModal1 = () => {
    setIsModalOpen1(true);
    form.resetFields();
  };
  const handleCancel1 = () => {
    setIsModalOpen1(false);
    form.resetFields();
  };

  const activePatient = JSON.parse(sessionStorage.getItem("patient"));

  const patientName = `${activePatient?.salutation || ""} ${activePatient?.firstName || ""
    } ${activePatient?.lastName || ""}`.trim();

  const updatedPrescriptionsList = prescriptionsList.map((prescription) => ({
    ...prescription,
    patientName: patientName,
  }));

  const fetchPatientPermission = async () => {
    if (permissionData && permissionData.prescription === "Y") {
      fetchAllPrescriptions(permissionData.prescription);
    }
  };

  const fetchAllPrescriptions = async (permission) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));

    let payload = {
      patientId: selectedPatient?.patientId,
      detailsYN: "Y",
      fromDate: formatDate(firstDate),
      toDate: formatDate(lastDate),
      status: 2,
    };
    setLoading(true);
    await ConsultationService.getPrescriptions(payload)
      .then((result) => {
        setPrescriptionsList(result.data);
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setPrescriptionsList([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClick = (presc) => {
    setIsModalOpen(true);
    setSelectedPrescription(presc);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFinish = async () => {
    let payload = form.getFieldValue();
    payload.userId = loginResultObject.user.userId;
    payload.fromDate = fromDate;
    payload.toDate = toDate;

    await ConsultationService.getPrescriptions(payload)
      .then((result) => {
        setPrescriptionsList(result.data);
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setPrescriptionsList([]);
      });
    handleCancel1();
  };
  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patientName",
    },

    {
      title: "Appointment Id",
      dataIndex: "appointmentId",
    },
    {
      title: "Consultation Reason",
      dataIndex: "consultationReason",
    },
    {
      title: "Doctor Name",
      dataIndex: "userId",
      render: (_, record) => (
        <Space size="middle" className="">
          {record.userName}
        </Space>
      ),
    },
    {
      title: "Clinic Name",
      dataIndex: "clinic_Name",
    },
    {
      title: "Date",
      dataIndex: "consultationDate",
      render: (_, record) => (
        <Space size="middle" className="">
          {record.consultationDate.slice(0, 10)}
        </Space>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <Space size="middle" className="">
          <button
            className="p-2 rounded-md text-white flex items-center bg-[#3b98b9]  justify-center"
            onClick={() => handleClick(record)}
          >
            View prescription
          </button>
        </Space>
      ),
    },
  ];
  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleMonthFilter = (value) => {
    const formattedDate = "01";
    const formattedMonth = value.format("MM");
    const formattedYear = value.format("YYYY");
    const fromDate = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    const fromDateMoment = moment(fromDate, "MM/DD/YYYY");
    const lastDayOfMonth = fromDateMoment.endOf("month").format("MM/DD/YYYY");
    const toDate = lastDayOfMonth;

    setFromDate(fromDate);
    setToDate(toDate);

    let payload = {
      userId: loginResultObject.user.userId,
      fromDate: fromDate,
      toDate: toDate,
      patientId: selectedPatient?.patientId,
      detailsYN: "Y",
    };

    ConsultationService.getPrescriptions(payload)
      .then((result) => {
        setPrescriptionsList(result.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
  };

  return (
    <div>
      <div className="w-full flex justify-end mb-4">
        <DatePicker
          onChange={handleMonthFilter}
          picker="month"
          format="MMM YYYY"
          defaultValue={dayjs()}
          allowClear={false}
        />
        <div className="flex ml-4 items-center justify-end">
          <button
            style={{ position: "relative", left: "0rem" }}
            className="text-white font-semibold p-2 bg-[#3b98b9]  rounded-md flex items-center "
            onClick={showModal1}
          >
            <FaFilter className="mr-1" />
            Filter
          </button>
        </div>
      </div>
      {loading ? (
        <div className="w-full flex h-screen justify-center items-center">
          <div className="spinner"></div>
        </div>
      ) : !prescriptionsList || prescriptionsList.length === 0 ? (
        <div className="w-full flex flex-col h-screen justify-center items-center">
          <div className="w-full flex flex-col justify-center items-center">
            <img src={NoDataFound} alt="No Data" className="w-96 h-96" />
          </div>

          <p className="mt-4">No prescriptions found for the selected month.</p>
        </div>
      ) : (
        <Table dataSource={updatedPrescriptionsList} columns={columns} />
      )}

      <Modal
        title={<span className="font-bold">Filter</span>}
        className="commonModal"
        footer={false}
        open={isModalOpen1}
        onOk={showModal1}
        onCancel={handleCancel1}
      >
        <Form
          layout="vertical"
          autoComplete="off"
          className=" grid grid-cols-2 gap-5"
          form={form}
          onFinish={handleFinish}
        >
          <Form.Item className="mb-0" label="Doctor Name" name="userName">
            <Input className="w-full" />
          </Form.Item>
          <Form.Item className="mb-0" label="Clinic Name" name="clinic_Name">
            <Input className="w-full" />
          </Form.Item>
          <Form.Item>
            <div
              className="flex justify-end   border-brand-colorBorder gap-3 pt-2"
              style={{ position: "relative", left: "16rem" }}
            >
              <button
                className="border rounded-lg bg-white text-sm w-40"
                onClick={handleCancel1}
              >
                Cancel
              </button>
              <button
                className="bg-brand-primaryColor border rounded-lg  w-40 p-2 text-sm text-white"
                type="primary"
                htmlType="submit"
              >
                Submit
              </button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        style={{ top: 40 }}
        width={"90%"}
        footer={[]}
      >
        <PrescriptionDetails
          prescription={selectedPrescription}
          selectedPatient={selectedPatient}
        />
      </Modal>
    </div>
  );
}

export default ViewPrescription;
